"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addonsWithMultipleValues = exports.SUPERSIZE_MY_EDIT = exports.SIMPLE_GRAPHICS = exports.OTHER = exports.ADDITIONAL_MEDIA = exports.ADDITIONAL_AMENDMENTS = void 0;
var SUPERSIZE_MY_EDIT = 'SUPERSIZE_MY_EDIT';
exports.SUPERSIZE_MY_EDIT = SUPERSIZE_MY_EDIT;
var OTHER = 'OTHER';
exports.OTHER = OTHER;
var ADDITIONAL_AMENDMENTS = 'ADDITIONAL_AMENDMENTS';
exports.ADDITIONAL_AMENDMENTS = ADDITIONAL_AMENDMENTS;
var ADDITIONAL_MEDIA = 'ADDITIONAL_MEDIA';
exports.ADDITIONAL_MEDIA = ADDITIONAL_MEDIA;
var SIMPLE_GRAPHICS = 'SIMPLE_GRAPHICS';
exports.SIMPLE_GRAPHICS = SIMPLE_GRAPHICS;
var addonsWithMultipleValues = [OTHER, ADDITIONAL_AMENDMENTS];
exports.addonsWithMultipleValues = addonsWithMultipleValues;